import { useEffect } from 'react'

const SITIO = 'https://colibripremium.store'
const NOMBRE = 'Colibrí Premium Service'

/**
 * Ajusta el título, la descripción y la URL canónica según la pantalla.
 *
 * El index.html tiene un solo juego de meta tags, así que sin esto las cinco
 * rutas públicas comparten título y descripción y Google las ve como la misma
 * página. Google ejecuta el JS antes de indexar, así que alcanza con escribirlas
 * en el head al montar cada pantalla.
 *
 * Los scrapers de redes (WhatsApp, Facebook) NO ejecutan JS: para ellos vale lo
 * que está en index.html, que es el og: del sitio.
 *
 * @param titulo      va antes del nombre del sitio en la pestaña
 * @param descripcion meta description de esta pantalla
 * @param ruta        path canónico, sin dominio. null = no tocar la canónica
 * @param noIndex     true en pantallas que no deben aparecer en buscadores
 */
const useSeo = ({ titulo, descripcion, ruta, noIndex = false }) => {
  useEffect(() => {
    if (titulo) {
      document.title = `${titulo} | ${NOMBRE}`
    }

    const ponerMeta = (selector, atributo, valor) => {
      if (!valor) return
      let tag = document.querySelector(selector)
      if (!tag) {
        tag = document.createElement('meta')
        const [clave, contenido] = selector
          .replace(/meta\[|\]/g, '')
          .split('=')
        tag.setAttribute(clave, contenido.replace(/"/g, ''))
        document.head.appendChild(tag)
      }
      tag.setAttribute(atributo, valor)
    }

    ponerMeta('meta[name="description"]', 'content', descripcion)
    // og:title y og:description se actualizan para los buscadores que sí
    // ejecutan JS; el valor de index.html queda como respaldo.
    ponerMeta('meta[property="og:title"]', 'content', titulo ? `${titulo} | ${NOMBRE}` : null)
    ponerMeta('meta[property="og:description"]', 'content', descripcion)

    if (ruta !== null && ruta !== undefined) {
      const url = `${SITIO}${ruta}`
      let canonica = document.querySelector('link[rel="canonical"]')
      if (!canonica) {
        canonica = document.createElement('link')
        canonica.setAttribute('rel', 'canonical')
        document.head.appendChild(canonica)
      }
      canonica.setAttribute('href', url)
      ponerMeta('meta[property="og:url"]', 'content', url)
    }

    const robots = document.querySelector('meta[name="robots"]')
    if (robots) {
      robots.setAttribute(
        'content',
        noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'
      )
    }
  }, [titulo, descripcion, ruta, noIndex])
}

export default useSeo
